module.exports = "/_next/static/images/appearance_out-d6851f04116318ec6ae2934bf55e9fea.jpeg";